import { TableActionsMenuRoot } from "./table-actions-menu";
import { TableActionsMenuTrigger } from "./parts/trigger";
import { TableActionsMenuExportItem } from "./parts/view-export-item";
import { TableActionsMenuItem } from "./parts/view-item";
import { TableActionsMenuSettingsItem } from "./parts/view-settings-item";

export {
  TABLE_ACTIONS_EXPORT_LABEL,
  TABLE_ACTIONS_LABEL,
  TABLE_ACTIONS_SETTINGS_LABEL,
} from "./messages";
export type * from "./types-table-actions-menu";

/** Menu ⋮ da tabela (`TableActionsMenu.Root/Trigger/Item`, mais os atalhos `ExportItem` e `SettingsItem`). */
export const TableActionsMenu = {
  Root: TableActionsMenuRoot,
  Trigger: TableActionsMenuTrigger,
  Item: TableActionsMenuItem,
  ExportItem: TableActionsMenuExportItem,
  SettingsItem: TableActionsMenuSettingsItem,
};
